import api from '../../utils/axios';

const login = async (email, password) => {
  const { data } = await api.post(
    `/users/login`,
    {
      email,
      password,
    },
    { authorization: false }
  );

  return data;
};

const checkForEmail = async (email) => {
  const { data } = await api.get(`/users/check-email/${email}`);

  return data;
};

const createOtp = async (userId) => {
  const { data } = await api.get(`/users/${userId}/otp`);

  return data;
};

const validateOtp = async (userId, otp) => {
  const { data } = await api.post(`/users/${userId}/otp`, {
    otp,
  });

  return data;
};

const userByID = async (userId) => {
  const { data } = await api.get(`/users/${userId}`);

  return data;
};

const updateUserByID = async (userId, fields) => {
  const { data } = await api.patch(`/users/${userId}`, fields);

  return data;
};

const userStripeSetup = async (userId, customerId) => {
  const { data } = await api.get(`/users/${userId}/stripe/${customerId}/setup`);

  return data;
};

const userForgotPassword = async (email) => {
  return api.post(
    '/users/forgot-password',
    { email },
    { authorization: false }
  );
};

const userService = {
  login,
  createOtp,
  validateOtp,
  userByID,
  updateUserByID,
  userStripeSetup,
  userForgotPassword,
  checkForEmail,
};

export default userService;
